/**
 * Determines the side (buy/sell) based on position quantity and direction
 * - Long positions (quantity >= 0): increase=buy, decrease=sell
 * - Short positions (quantity < 0): increase=sell (adding to short), decrease=buy (covering short)
 */
export const getSideForPositionAdjustment = (quantity: number, direction: 'increase' | 'decrease'): 'buy' | 'sell' => {
    const isLongPosition = quantity >= 0;
    return (isLongPosition && direction === 'increase') || (!isLongPosition && direction === 'decrease')
        ? 'buy'
        : 'sell';
};

/**
 * Normalize adjustment value by converting to absolute value with minimum of 0
 */
export const normalizeAdjustment = (adjustment: number | undefined): number => {
    return Math.abs(adjustment ?? 0);
};

/**
 * Calculate adjustment quantity from position quantity and adjustment percentage
 * Formula: quantity * (adjustment / 100)
 * - If adjustment is 0, returns 0
 * - Result is rounded down to integer
 * - Minimum value is 1 (except when adjustment is 0)
 */
export const calculateAdjustmentQuantity = (quantity: number, adjustment: number): number => {
    if (adjustment === 0) {
        return 0;
    }
    const calculated = Math.abs(quantity) * (adjustment / 100);
    const rounded = Math.floor(calculated);
    return Math.max(1, rounded);
};
